import { DateFormats, formatDate } from '@strata/helper-functions';
import { InlineMessage } from '@strata/react-inline-message';
import dayjs from 'dayjs';

interface ProspectiveReferralInlineMessageProps {
    referralStart?: string;
    outreachDate?: string;
}

export const ProspectiveReferralInlineMessage = ({
    referralStart = undefined,
    outreachDate = undefined,
}: ProspectiveReferralInlineMessageProps) =>
    dayjs().isBefore(referralStart) && outreachDate != null ? ( // Ignore when outreach date is null for now
        <div className="margin__bottom--medium">
            <InlineMessage
                intent={InlineMessage.Intent.WARNING}
                title="Future Service Start Date"
                label={`Servicing of this upcoming referral cannot begin until the servicing start date of ${formatDate(referralStart, DateFormats.DATE_MEDIUM)}. Patient outreach can begin ${dayjs().isBefore(outreachDate) ? formatDate(outreachDate, DateFormats.DATE_MEDIUM) : 'now'}.`}
                wrapText
            />
        </div>
    ) : null;
